// @flow
import { createAction } from "redux-act";

export const openHamburgerMenu = createAction("Open Hamburger Menu");
export const closeHamburgerMenu = createAction("Close Hamburger Menu");


// WEBPACK FOOTER //
// ./src/modules/actions/uiMenu.js